<template>
  <div>
    <el-button type="primary" class="addBtn" @click="addIdentityClick">新增身份</el-button>
    <div class="table-wrap">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="group_title" label="管理员身份" align="center">
        </el-table-column>
        <el-table-column label="管理模块" align="center" prop="modules">
        </el-table-column>
        <el-table-column label="最后修改时间" align="center" prop="update_time">
        </el-table-column>
        <el-table-column label="操作" align="center" width="160">
          <template slot-scope="scope">
            <div class="operation-wrap">
              <span class="operation-item" @click="editIdentityClick(scope.row)">编辑</span>
              <span class="danger operation-item" @click="deleteIdentityClick(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <common-pagination :total="total" :page_size="page_size" @size-change="handelPagesizeChange"
                         @page-change="handlePageChange"></common-pagination>
      <IdentitylistDialog :dialogVisible="dialogVisible" :dialogTitle="dialogTitle" :dialogType="dialogType"
                          :handle_row="handle_row" :width="width" @close="handleDialogClose"
                          @cancel="handelDialogCancel">
      </IdentitylistDialog>
    </div>
  </div>
</template>

<script>
import {
  identityOf, getMenuList
} from "@/api/auth";
import CommonPagination from "@/components/CommonPagination";
import IdentitylistDialog from "./components/IdentitylistDialog";
import {
  mapState
} from "vuex";
import operations from "@/mixins/operations";

export default {
  name: "identitymanage",
  mixins: [operations],
  data() {
    return {
      tableData: [],
      page_index: 1, //第几页
      page_size: 50,
      total: 100, //总条数
      dialogVisible: false,
      dialogTitle: "",
      dialogType: "",
      handle_row: {},
      three_rules: [],
      width: "",
      menuList: []
    };
  },
  components: {
    CommonPagination,
    IdentitylistDialog
  },
  computed: {
    ...mapState(["operationList"])
  },
  mounted() {
    this.getMenuList();
    this.getIdentityList();
  },
  methods: {
    async getMenuList() {
      let postData = {
        page_size: 99999,
        page_index: 1,
      };
      const {
        status,
        data
      } = await getMenuList(postData);
      if (status !== 200) return;
      this.menuList = data.result.data
    },
    async getIdentityList() {
      let postData = {
        page_index: this.page_index,
        page_size: this.page_size
      };
      const {
        data,
        status
      } = await identityOf(postData);
      if (status !== 200) return;
      if (data.result.data.length) {
        data.result.data.forEach(item => {
          if (item.menu_rules && item.menu_rules.length) {
            item.modules = item.menu_rules_name.join("/")
          }
        });
      }
      this.tableData = data.result.data;
      this.total = data.result.total;
    },
    addIdentityClick() {
      // this.dialogType = 'add';
      // this.dialogTitle = '新增身份';
      // this.dialogVisible =  true;
      // this.width = '50%';
      this.$router.push("/add-role");
    },
    editIdentityClick(row) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.$router.push({
        path: "/edit-role",
        query: this.handle_row
      });
      // console.log(row, '编辑身份')
      // this.dialogType = 'edit';
      // this.dialogTitle = '编辑身份';
      // this.dialogVisible = true;
      // this.width = '50%';
    },
    deleteIdentityClick(row) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.dialogType = "delete";
      this.dialogTitle = "删除身份";
      this.dialogVisible = true;
      this.width = "30%";
    },
    handelPagesizeChange(size) {
      this.page_size = size;
      this.getIdentityList();
    },
    handlePageChange(page) {
      this.page_index = page;
      this.getIdentityList();
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.handle_row = {};
      this.getIdentityList();
    },
    handelDialogCancel() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.addBtn {
  float: right;
  margin-bottom: 30px;
  .addBtn();
}

.table-wrap {
  .table-wrap();
}
</style>
